export default __webpack_public_path__ + "static/media/sublime.4ed1225a.svg";